import * as React from 'react';
import cn from 'classnames';
import moment, { Moment } from 'moment';
import styles from './work-item-list.module.css';
import LoadingSpinner from '../../components/LoadingSpinner';
import { WaiverConfiguration } from '../../types/waiver';

interface Props {
  className: string;
  snoozedWaiverConfigurations?: WaiverConfiguration[];
  onSnoozeCancel: (airlineCode: string) => void;
  now: Moment;
  loading: boolean;
  open: boolean;
  mouseover: boolean;
};

interface State {
  open: boolean;
  mouseover: boolean;
};

export default class AirlineSnoozeStatus extends React.Component<Props, State> {
  state = {
    open: this.props.open,
    mouseover: this.props.mouseover,
  };

  static defaultProps = {
    open: false,
    mouseover: false,
    className: '',
  };

  toggleOpen = () =>
    this.setState(previousState => ({ open: !previousState.open }));

  onMouseEnter = () => this.setState({ mouseover: true });

  onMouseLeave = () => this.setState({ mouseover: false });

  render() {
    if (
      !this.props.snoozedWaiverConfigurations ||
      this.props.snoozedWaiverConfigurations.length === 0
    ) {
      return null;
    }

    const snoozedConfigs = this.props.snoozedWaiverConfigurations;
    const snoozedAirlineCount = snoozedConfigs.length;
    if (snoozedAirlineCount === 0) {
      return null;
    }

    const arrowColor = this.state.mouseover ? 'ivory' : 'choc';
    const arrowDirection = this.state.open ? 'up' : 'down';

    return (
      <div className={cn(this.props.className, styles.airlineSnoozeStatus)}>
        <div
          className={cn(styles.airlineSnoozeStatusButton)}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          onClick={this.toggleOpen}
        >
          {snoozedAirlineCount}{' '}
          {snoozedAirlineCount === 1 ? 'airline' : 'airlines'} snoozed
          {this.props.loading ? (
            <LoadingSpinner className={styles.airlineSnoozeStatusArrow} />
          ) : (
            <i
              className={cn(
                styles.airlineSnoozeStatusArrow,
                'sprites',
                `sprite-arrow-${arrowColor}-${arrowDirection}`,
              )}
            />
          )}
        </div>
        <div className={cn(styles.airlineSnoozeStatusContent)}>
          {this.state.open &&
            snoozedConfigs.map(config => (
              <SnoozedAirline
                key={config.waiverTemplate.issuingAirlineCode}
                airlineCode={config.waiverTemplate.issuingAirlineCode}
                snoozedUntil={config.snoozeNotificationsUntil}
                now={this.props.now}
                onCancel={this.props.onSnoozeCancel}
              />
            ))}
        </div>
      </div>
    );
  }
}

interface SnoozedAirlineProps {
  airlineCode: string;
  snoozedUntil?: string;
  now: Moment;
  onCancel: (code: string) => any;
};

const SnoozedAirline = (props: SnoozedAirlineProps) => {
  const snoozeDuration = moment
    .duration(moment(props.snoozedUntil).diff(props.now))
    .humanize();
  return (
    <div className={cn(styles.airlineSnoozeRow)}>
      <div className={cn(styles.airlineSnoozeAirline)}>
        {props.airlineCode} - {snoozeDuration}
      </div>
      <div
        className={cn(styles.airlineSnoozeCancel)}
        onClick={() => props.onCancel(props.airlineCode)}
      >
        Cancel
      </div>
    </div>
  );
};